export const formatCurrency = (v, currency = "COP") => {
  const num = Number(v)
  if (!isFinite(num)) return "—"
  return new Intl.NumberFormat("es-CO", {
    style: "currency", currency, maximumFractionDigits: 0,
  }).format(num)
}

export const formatNumber = (v, decimals = 0) => {
  const num = Number(v)
  if (!isFinite(num)) return "—"
  return new Intl.NumberFormat("es-CO", {
    minimumFractionDigits: decimals, maximumFractionDigits: decimals,
  }).format(num)
}

export const formatFecha = iso => {
  if (!iso) return "—"
  try {
    return new Date(iso).toLocaleDateString("es-CO", {
      year: "numeric", month: "short", day: "2-digit",
    })
  } catch { return iso }
}

export const formatFechaHora = iso => {
  if (!iso) return "—"
  try {
    return new Date(iso).toLocaleString("es-CO", {
      year: "numeric", month: "short", day: "2-digit",
      hour: "2-digit", minute: "2-digit",
    })
  } catch { return iso }
}

export const PALETA = [
  "#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6",
  "#ec4899", "#06b6d4", "#84cc16", "#f97316", "#6366f1",
]

export const colorPara = i => PALETA[i % PALETA.length]

export const TIPO_COMPROBANTE = {
  "01": "Factura de venta",
  "02": "Nota débito",
  "03": "Nota crédito",
  "04": "Documento soporte",
  "05": "Doc. equivalente",
  "91": "Nota crédito",
  "92": "Nota débito",
  "95": "Doc. equivalente",
}

// Regla POS aplicada al método de pago → config visual
export const reglaConfig = regla => {
  switch (regla) {
    case "ajuste_unico":
      return { label: "Único", color: "#065f46", bg: "#d1fae5", desc: "Método único, valor ajustado al total" }
    case "ajuste_efectivo":
      return { label: "Efectivo ajustado", color: "#1e40af", bg: "#dbeafe", desc: "Mixto: efectivo recalculado para cuadrar" }
    case "sin_ajuste":
      return { label: "Sin ajuste", color: "#991b1b", bg: "#fee2e2", desc: "Requiere revisión manual" }
    default:
      return { label: regla || "—", color: "#475569", bg: "#f1f5f9", desc: "" }
  }
}

// Eventos Postmark/email → config visual
export const eventoCorreoConfig = evento => {
  const e = (evento || "").toLowerCase()
  if (e.includes("delivery") || e.includes("entreg"))
    return { color: "#10b981", bg: "#d1fae5", icon: "email-check-outline", label: "Entregado" }
  if (e.includes("open") || e.includes("abierto"))
    return { color: "#3b82f6", bg: "#dbeafe", icon: "email-open-outline", label: "Abierto" }
  if (e.includes("click"))
    return { color: "#8b5cf6", bg: "#ede9fe", icon: "cursor-default-click", label: "Click" }
  if (e.includes("bounce") || e.includes("rebot"))
    return { color: "#ef4444", bg: "#fee2e2", icon: "email-alert-outline", label: "Rebotó" }
  if (e.includes("spam") || e.includes("complaint"))
    return { color: "#dc2626", bg: "#fef2f2", icon: "email-remove-outline", label: "Spam" }
  if (e.includes("send") || e.includes("env"))
    return { color: "#64748b", bg: "#f1f5f9", icon: "email-outline", label: "Enviado" }
  return { color: "#475569", bg: "#f1f5f9", icon: "email-outline", label: evento || "—" }
}
